import { Platform, SafeAreaView, ScrollView, StyleSheet } from 'react-native'
import { useTheme } from 'styled-components'
import Icon from '../../../../../elements/images/Icon'
import { useMediaIs } from '../../../../../style/media'
import ActorFeaturedDetails from '../../../../actors/ActorFeaturedDetails/ActorFeaturedDetails'
import messages from '../../../messages'
import Button, { desktopBtnSize, smallBtnSize } from '../../PlayerControls/Button'
import { Controls } from '../../PlayerControls/PlayerControls'

const isIOS = Platform.OS === 'ios'

const styles = StyleSheet.create({
  flex: { flex: 1 },
  opaqueBg: { backgroundColor: '#121212dd' },
})

const FeaturedActorDetails = ({ actor, desktopBtns, onBack }) => {
  const theme = useTheme()
  const atLeastTablet = useMediaIs('sm')
  const iconSize = desktopBtns
    ? desktopBtnSize(theme.fontSizes.medium)
    : smallBtnSize(theme.fontSizes.medium, atLeastTablet)
  return (
    <SafeAreaView style={styles.flex}>
      <Controls.Header style={styles.opaqueBg}>
        <Controls.Buttons>
          {onBack && (
            <Button
              onPress={onBack}
              fontStyle={{ marginTop: -4, marginLeft: -11 }}
              intlMsg={isIOS ? messages.back : undefined}
            >
              <Icon name="back" size={iconSize} />
            </Button>
          )}
        </Controls.Buttons>
      </Controls.Header>

      <ScrollView style={[styles.flex, styles.opaqueBg]}>
        {actor?.name && <ActorFeaturedDetails actor={actor} />}
      </ScrollView>
    </SafeAreaView>
  )
}

export default FeaturedActorDetails
